import { cn } from '@/foundation/utils/cn';

interface Attribution {
  required: boolean;
  name: string | null;
  nameUrl: string | null;
  source: string | null;
  sourceUrl: string | null;
}

interface MediaAttributionProps {
  attribution: Attribution | null;
  className?: string;
}

export function MediaAttribution({ attribution, className }: MediaAttributionProps) {
  if (!attribution) return null;
  if (!attribution.required && !attribution.name) return null;

  return (
    <p
      className={cn('mt-1', className)}
      style={{
        fontFamily: 'var(--font-sans, var(--f-font-sans))',
        fontSize: 'var(--text-xs, var(--f-text-xs))',
        color: 'var(--color-text-muted, var(--f-fg-muted))',
      }}
    >
      {attribution.name && (
        <>
          {'Photo by '}
          {attribution.nameUrl ? (
            <a
              href={attribution.nameUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
              style={{ color: 'var(--color-text-muted, var(--f-fg-muted))' }}
            >
              {attribution.name}
            </a>
          ) : (
            attribution.name
          )}
        </>
      )}
      {attribution.source && (
        <>
          {attribution.name ? ' on ' : ''}
          {attribution.sourceUrl ? (
            <a
              href={attribution.sourceUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
              style={{ color: 'var(--color-text-muted, var(--f-fg-muted))' }}
            >
              {attribution.source}
            </a>
          ) : (
            attribution.source
          )}
        </>
      )}
    </p>
  );
}
